module.exports = __webpack_public_path__ + "img/signup_carousel_2.27d6af38.svg";